export default __webpack_public_path__ + "static/imgGAPpng-1903e1f3aa0ba9c276d97f73675f0f55.png";